var wellKnownSymbol = require('../internals/well-known-symbol');

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/internals/to-string-tag-support.js
// module id = 150
// module chunks = 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35